module.exports = __webpack_public_path__ + "img/go-top.4d43e9db.svg";